import { render } from "./TournamentArenaEditPage.vue?vue&type=template&id=71c49a93"
import script from "./TournamentArenaEditPage.vue?vue&type=script&lang=js"
export * from "./TournamentArenaEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__